/*
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-23 18:15:14
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-08 13:43:53
 * @FilePath: /goldenSalesMobile/src/utils/auth.js
 * @Description: 获取token 、存储token 、删除token
 */
const TokenKey = 'userToken'
const OpenIdKey = 'OpenId'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function getLocalOpenId() {
  return localStorage.getItem(OpenIdKey)
}

export function setLocalOpenId(openId) {
  return localStorage.setItem(OpenIdKey, openId)
}
